import { format, parseISO } from "date-fns";

export const toISOFormat = (maybeDate: Date | string): string => {
  const date = typeof maybeDate === "string" ? parseISO(maybeDate) : maybeDate;
  return format(date, "yyyy-MM-dd");
};

export const formatShortFormDate = (dateTime: string | null, dateFormatOverride?: string) => {
  if (!dateTime) return "";
  const date = parseISO(dateTime);
  return format(date, dateFormatOverride || "MMM d, yyyy");
};

export const formatFullDateAndTime = (dateTime: string, dateFormatOverride?: string) => {
  const date = parseISO(dateTime);
  return format(date, dateFormatOverride || "MMMM d, yyyy 'at' h:mm a");
};

export const formatFullDateAndTimeWithLocalTimezone = (
  dateTime: string,
  dateFormatOverride?: string,
  includeTzName = false,
) => {
  let date = parseISO(dateTime);
  const offset = -date.getTimezoneOffset();
  date = new Date(date.getTime() + offset * 60 * 1000);
  let formattedDate = format(date, dateFormatOverride || "MMMM d, yyyy 'at' h:mm a");
  if (includeTzName) {
    const timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
    formattedDate += ` ${timeZoneName}`;
  }
  return formattedDate;
};

// V2: uses Intl.DateTimeFormat().formatToParts() to get the short timezone
// abbreviation (e.g. "PST", "EST") rather than the IANA name (e.g.
// "America/Los_Angeles") that the original produces when includeTzName is true.
export const formatLocalDateTime = (
  dateTime: string,
  dateFormatOverride?: string,
  includeTzName = false,
) => {
  const date = parseISO(dateTime);
  let formattedDate = format(date, dateFormatOverride || "MMMM d, yyyy 'at' h:mm a");
  if (includeTzName) {
    const timeZoneName =
      Intl.DateTimeFormat(undefined, { timeZoneName: "short" })
        .formatToParts(date)
        .find((part) => part.type === "timeZoneName")?.value ?? "";
    formattedDate += ` ${timeZoneName}`;
  }
  return formattedDate;
};
